module.exports = __webpack_public_path__ + "img/google-3x.495ba0ae.png";